/**
 * Carbon breadcrumb (DESIGN.md "Navigation"): 14px, parents in the link
 * color, "/" separators in helper text, the current page in primary text.
 * There is no h1 page title: the breadcrumb names the page. It wraps rather
 * than overflow on phones.
 */
import { Fragment } from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import type { BreadcrumbProps } from './types'

export function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className={clsx('min-w-0', className)}>
      <ol className="m-0 flex list-none flex-wrap items-center gap-2 p-0 text-body text-text-secondary">
        {items.map((item, i) => {
          const last = i === items.length - 1
          return (
            <Fragment key={`${item.label}-${i}`}>
              <li className="min-w-0">
                {last ? (
                  <span aria-current="page" className="text-text-primary">
                    {item.label}
                  </span>
                ) : item.to ? (
                  <Link to={item.to} className="text-link hover:text-link-hover hover:underline">
                    {item.label}
                  </Link>
                ) : (
                  item.label
                )}
              </li>
              {last ? null : (
                <li aria-hidden="true" className="text-text-helper">
                  /
                </li>
              )}
            </Fragment>
          )
        })}
      </ol>
    </nav>
  )
}

export default Breadcrumb
